import textMessageApi from '@/api/textMessage';
import { loadEntity, enhanceOrAdd } from '@/helpers/utility';

const state = {
    byId: {},
};

const actions = {
    async getTextMessages(store, { page, withoutCustomers }) {
        let pagedTextMessages = await textMessageApi.list({ page, withoutCustomers });
        let ids = loadEntity({ textMessages: pagedTextMessages.data });
        return { ids, meta: pagedTextMessages.meta };
    },
    async getTextMessagesForCustomer({ dispatch }, { customer }) {
        let textMessages = await textMessageApi.getForCustomer(customer);
        loadEntity({ textMessages });
    },
    async getTextMessagesForPhoneNumber(store, { phoneNumber }) {
        let textMessages = (await textMessageApi.getForPhoneNumber(phoneNumber)).data;
        loadEntity({ textMessages });
    },
    async sendTextMessageToCustomer({ dispatch }, { customer, textMessage }) {
        textMessage = await textMessageApi.sendToCustomer(customer, textMessage);
        loadEntity({ textMessage });
    },
    async sendTextMessageToPhoneNumber(store, { phoneNumber, textMessage }) {
        textMessage = await textMessageApi.sendToPhoneNumber(phoneNumber, textMessage);
        loadEntity({ textMessage });
    },
    subscribe({ dispatch }, { channels }) {
        if (channels.indexOf('textMessages') === -1)
            return;

        Echo.leave('textMessages');

        Echo.private('textMessages')
            .listen('TextMessages.TextMessageUpdated', (e) => loadEntity({ textMessage: e.textMessage }));
    },
    unsubscribe(store, { channels }) {
        if (channels.indexOf('textMessages') === -1)
            return;

        Echo.leave('textMessages');
    },
};

const mutations = {
    LOAD_ENTITIES(state, { textMessages }) {
        if (textMessages)
            Object.values(textMessages).forEach(textMessage => enhanceOrAdd(state.byId, textMessage.id, textMessage));
    },
    UPDATE_TEXTMESSAGE(state, { textMessage }) {
        enhanceOrAdd(state.byId, textMessage.id, textMessage);
    },
};

export default {
    state,
    actions,
    mutations,
};
